import React, { FC } from 'react';
import { ExtendedUser } from '../../../../shared/user/extended';
import { Fetcher, isAccessError, useFetcher } from '../../../utils';
import { fetchDealerData } from '../../apply/dealer/DealerArea';
import { DealerBan } from '../../apply/dealer/DealerBan';
import { DealerFormComponent, DealerFormUser } from '../../apply/dealer/DealerForm';

interface TabDetailsProps {
  readonly user: ExtendedUser;
}

export const UserDealerTab: FC<TabDetailsProps> = ({ user }) => {
  const fetcher = useFetcher(async () => {
    return await fetchDealerData(user.id);
  }, [user.id]);

  if (!fetcher.success) {
    if (fetcher.error && isAccessError(fetcher.error)) {
      return <DealerBan />;
    }

    return <Fetcher result={fetcher} />;
  }

  const dealerUser: DealerFormUser = {
    id: user.id,
    addressCity: user.address?.city ?? '',
    addressCountry: user.address?.country ?? '',
    addressLine1: user.address?.line1 ?? '',
    addressLine2: user.address?.line2 ?? null,
    addressState: user.address?.state ?? '',
    addressZipcode: user.address?.zipcode ?? '',
  };

  return <DealerFormComponent callback={fetcher.refresh} user={dealerUser} {...fetcher.data} />;
};
